var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#C86406"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C13.584 10 10 13.584 10 18C10 22.416 13.584 26 18 26C22.416 26 26 22.416 26 18C26 13.584 22.416 10 18 10ZM14 19.2C13.336 19.2 12.8 18.664 12.8 18C12.8 17.336 13.336 16.8 14 16.8C14.664 16.8 15.2 17.336 15.2 18C15.2 18.664 14.664 19.2 14 19.2ZM18 19.2C17.336 19.2 16.8 18.664 16.8 18C16.8 17.336 17.336 16.8 18 16.8C18.664 16.8 19.2 17.336 19.2 18C19.2 18.664 18.664 19.2 18 19.2ZM22 19.2C21.336 19.2 20.8 18.664 20.8 18C20.8 17.336 21.336 16.8 22 16.8C22.664 16.8 23.2 17.336 23.2 18C23.2 18.664 22.664 19.2 22 19.2Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup13);
export default __webpack_public_path__ + "static/media/Group 1 (3).e29f50df560fdd9fd9959b5edf052d9f.svg";
export { ForwardRef as ReactComponent };